import { ReactElement } from 'react';

import { QuickLinksContent } from '../../../types';
import { SearchTitleHeader } from './SearchTitleHeader';

type QuickLinksProps = {
  quickLinks?: QuickLinksContent;
};

export const QuickLinksView = ({ quickLinks }: QuickLinksProps): ReactElement => {
  if (!quickLinks || !quickLinks.links) {
    return <></>;
  }

  return (
    <>
      {quickLinks.links.length ? (
        <>
          <SearchTitleHeader title={quickLinks.label?.value || ''} />
          <div
            className="mb-10 mt-1.5 grid w-full grid-cols-1 gap-2 xs:grid-cols-2 lg:grid-cols-3"
            role="list"
          >
            {quickLinks.links.map((link) => {
              return (
                <a
                  key={`quicklink-${link.id}`}
                  href={link.Link?.value?.href || '#'}
                  className="cursor-pointer border-b border-solid border-gray-100 pb-1"
                  role="listitem"
                >
                  {link.Title?.value || link.TitleDictionary?.Phrase?.value || ''}
                </a>
              );
            })}
          </div>
        </>
      ) : null}
    </>
  );
};
